// extracted by mini-css-extract-plugin
export default {"search-results":"SearchResults_search-results__DG54c","users":"SearchResults_users__G302C","posts":"SearchResults_posts__PIqVL"};